module.exports = __webpack_public_path__ + "img/tk-back.0fad282e.png";